import React, { useState, useEffect } from "react";

const Main = () => {
  const [networkCard, setNetworkCard] = useState([
    { img: "./images/nt1.png", btn_lbl: "Arte Digital" },
    { img: "./images/nt2.png", btn_lbl: "Pintura" },
    { img: "./images/nt3.png", btn_lbl: "Escultura" },
    { img: "./images/nt4.png", btn_lbl: "Fotografía" },
    { img: "./images/nt5.png", btn_lbl: "Vídeos" },
    { img: "./images/nt6.png", btn_lbl: "Antiguedades" },
    { img: "./images/nt7.png", btn_lbl: "Prelanzamientos" },
    { img: "./images/nt8.png", btn_lbl: "Tokenizados" },
    { img: "./images/nt9.png", btn_lbl: "Destacados" },
  ]);

  return (
    <div className="home-page flex flex-col">
      <div className="home-sec flex aic">
        <div className="left flex aic jc">
          <div className="meta flex flex-col aic jc">
            <div className="slogen">
              Descubre el universo del arte a través de los NFTs{" "}
            </div>
            <div className="see-more flex aic jc">
              <div className="btn-exp button">Explorar</div>
            </div>
            <div className="actions flex aic">
              <div className="btn button">Comprar</div>
              <div className="btn button">Crear y vender</div>
            </div>
          </div>
        </div>
        <div className="right flex">
          <img src="./images/home-bg.png" className="home-bg" />
        </div>
      </div>
      <div className="nft-network flex">
        <div className="wrapWidth wrap flex">
          <div className="network-block flex flex-col">
            <div className="network-tag text-center">
              Elige tu obra de arte en formato NFT
            </div>
            <div className="network-wrap">
              {networkCard.map((item, index) => (
                <div className="card flex aic jc">
                  <div
                    className="card-center"
                    style={{ backgroundImage: `url(${item.img})` }}
                  >
                    <div className="action flex aic jc">
                      <div className="btn button flex aic">{item.btn_lbl}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="see-more flex aic jc">
              <div className="btn button">Ver todos </div>
            </div>
          </div>
        </div>
      </div>
      <div className="comming-soon-sec flex aic">
        <div className="left flex flex-col">
          <div className="container flex flex-col">
            <div className="tag">Próximamente</div>
            <div className="date">Obra: San Luiz de Gonzada (1798-1800)</div>
            <div className="meta flex flex-col">
              <div className="t-nft">Total NFTs: 7.001 Units</div>
              <div className="pre-sale">Preventa: 1 de junio</div>
              <div className="pre-sale">Venta pública: 8 de junio</div>
            </div>
          </div>
          <div className="left-action flex aic jc">
            <div className="btn button">Acceder a la subasta</div>
          </div>
        </div>
        <div className="right flex flex-col">
          <div
            className="right-bg"
            style={{ backgroundImage: `url(./images/Retrato-de-Goya.png)` }}
          >
            <div className="ri-tag">
              Francisco de Goya
              <br /> y Lucientes
            </div>
          </div>
        </div>
      </div>
      <div className="about-us flex flex-col">
        <div className="about-us-tag flex aic jc">
          Quiénes <span className="aut">somos</span>
        </div>
        <div className="desc-sec flex aic jc">
          <div className="desc">
            El marketplace para la compra y venta
            <br /> de NFTs especializado en el sector del arte <br />{" "}
            <span> más completo y selectivo del mercado.</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
